import React, {useState} from "react";
import {useSelector} from "react-redux";
import {
    getStops,
    getSteps,
    getStepGeojson,
    getDeparture,
    getArrival,
    getCurrentDirection
} from '../../../../../data/booking/selectors/hike'
import {
    BAG_TRANSPORT,
    REGULAR_SHUTTLE,
    CAR_PARKING,
    CAR_TRANSPORT,
    BIKE_TRANSPORT,
    PEOPLE_TRANSPORT
} from "../../../../../data/booking/constants/service_types";
import {isEmpty} from "lodash";
import {
    BagTransport,
    BikeTransport,
    CarParking,
    CarTransport, PeopleTransport,
    RegularShuttle
} from "../../../../booking/components/map/leaflet/Services";
import KmlLayer from "../../../../booking/components/map/leaflet/KmlLayer";
import {Popup} from "react-leaflet";

function ServicesLayer(){
    const {hike, direction, kmlData, entities: {hikes, services, steps}} = useSelector(state => state.booking.map)
    const isLoop = hike?.pathDetails.loop

    let servicesComponents = null;
    let servicesKml = null;
    if(!isEmpty(services)) {
        let hikeIds = []
        servicesComponents = Object.keys(services).map(serviceId => {
            const service = services[serviceId]
            const departure = getDeparture(service.steps)
            const arrival = getArrival(service.steps)
            const currentDirection = getCurrentDirection(departure, arrival, steps)

            const hikeId = service.hike?.id ?? service.hike
            if(departure && hikeId) {
                if (!hikeIds.includes(hikeId)) {
                    hikeIds.push(hikeId)
                }
                switch (service.type) {
                    case BIKE_TRANSPORT:
                        return <BikeTransport key={serviceId} departure={departure} arrival={arrival}/>
                    case REGULAR_SHUTTLE:
                        return <RegularShuttle key={serviceId} departure={departure} arrival={arrival}/>
                    case PEOPLE_TRANSPORT:
                        return <PeopleTransport key={serviceId} departure={departure} arrival={arrival}/>
                    case CAR_TRANSPORT:
                        return <CarTransport key={serviceId} departure={departure} arrival={arrival}/>
                    case BAG_TRANSPORT:
                        let steps = getSteps(service)
                        let stops = getStops(service)
                        let geoJson = null;
                        if (kmlData && service.hike && kmlData[hikeId]) {
                            const {LineString} = kmlData[hikeId];
                            geoJson = getStepGeojson(departure, arrival, LineString, direction, isLoop && currentDirection == -1)
                        }
                        return <BagTransport key={serviceId} departure={departure} arrival={arrival} geoJson={geoJson}
                                             stops={stops}
                                             steps={steps}/>
                    case CAR_PARKING:
                        return <CarParking key={serviceId} departure={departure}/>
                }
            }
        })

        if(hikes) {
            servicesKml = hikeIds.map(hikeId => kmlData[hikeId] && <KmlLayer key={hikeId} kmlData={kmlData[hikeId]}>
                <Popup>
                    {hikes[hikeId].title}
                </Popup>
            </KmlLayer>)
        }
    }
    return <>
        {servicesComponents}
        {servicesKml}
    </>
}

export default ServicesLayer